import {Injectable} from '@angular/core';
import {Product, ProductOffering, UpgradeProtectionType} from '@uofu-uss-aux/software-catalog-ng-core';
import {min, parseISO} from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class LicensingService {

  pickEarliestEndDate(offers: ReadonlyArray<ProductOffering>): Date {
    const dates = (offers || [])
      .map(offer => offer.endDate)
      .filter(ed => !!ed)
      .map(ed => parseISO(ed));
    return dates.length ? min(dates) : null;
  }

  pickEarliestStartDate(offers: ReadonlyArray<ProductOffering>): Date {
    const dates = (offers || [])
      .map(offer => offer.startDate)
      .filter(sd => !!sd)
      .map(sd => parseISO(sd));
    return dates.length ? min(dates) : null;
  }

  productHasAnyOfferingsThatHaveProtection(product: Product): boolean {
    return !!product?.licenses?.find(l => this.anyOfferingsHaveAnyProtection(l.offerings));
  }

  anyOfferingsHaveProtectionOnly(offerings: ReadonlyArray<ProductOffering>): boolean {
    return !!offerings.find(off => off.upgradeProtectionType === UpgradeProtectionType.UpgradeProtectionOnly);

  }

  anyOfferingsHaveProtectionIncluded(offerings: ReadonlyArray<ProductOffering>): boolean {
    return !!offerings.find(off => off.upgradeProtectionType === UpgradeProtectionType.Included);

  }

  anyOfferingsHaveAnyProtection(offerings: ReadonlyArray<ProductOffering>): boolean {
    return !!offerings.find((offering: ProductOffering) => this.offeringHasAnyProtection(offering));
  }

  offeringHasAnyProtection(offering: ProductOffering): boolean {
    return offering.upgradeProtectionType === UpgradeProtectionType.Included ||
      offering.upgradeProtectionType === UpgradeProtectionType.UpgradeProtectionOnly;
  }
}
